export const dashboard = {
    selectedMeter: 'Ausgewähltes Messgerät:',
    analyticsLabel: 'Analytics',
    period: 'Periode:',
    refreshPeriod: 'Aktualisieren:',
    every1secs: 'Alle 1 Sekunden',
    every2secs: 'Alle 2 Sekunden',
    every5secs: 'Alle 5 Sekunden',
    every10secs: 'Alle 10 Sekunden',
    every30secs: 'Alle 30 Sekunden',
    every60secs: 'Alle 60 Sekunden',
    liveLoading: 'Live Monitoring',
    zoomIn: 'Zoom +',
    zoomOut: 'Zoom -',
    pvEfficiency: 'PV Effizienz',
    pvOwnUsage: 'PV Eigenverbrauch',
    pvProduced: 'Produziert/Verbraucht',
    pvSold: 'Produziert/Verkauft',
    pvUsed: 'Verbraucht',
    pvBought: 'Gekauft',
    cloudSubscription: 'Subskription',
    until: 'Bis',
    switchData: 'Schalter',
    noData: 'KEINE DATEN',
    wrongTime: 'Die Zeit auf ihrem Computer ist nicht korrekt eingestellt',
    secondGraph: '2ter Graph',
    premiumData: 'Premium Daten',
    premiumVoltage: 'Spannung V',
    premiumApparentPower: 'Scheinleistung VA',
    premiumCurrent: 'Stromstärke A',
    premiumCosPhi: 'CosPhi',
    downloadSvg: 'CSV Download',
    downloadExcel: 'Excel Download',
    onePerSecond: '1 Wert pro Sekunde',
    onePerMinute: '1 Wert pro Minute',
    onePer15Minutes: '1 Wert pro 15 Minuten',
    onePerHour: '1 Wert pro Stunde',
    resolution: 'Auflösung',
    kwhCost: 'Kosten pro Kilowatt',
    wattUnit: 'watt',
    kwUnit: 'Kilowatt',
    mwUnit: 'Megawatt',
    kwhUnit: 'KWh',
    kgUnit: 'Kilogramm',
    costUnit: '€',
    batteryCharge: 'Batterie Ladezustand',
    autonomy: 'Autonomie',
    grid: 'Netz',
    production: 'Produktion',
    battery: 'Batterie',
    usage: 'Verbrauch',
    otherDevices: 'Andere Geräte',
    chartModeDevice: 'Geräte',
    chartModePhases: 'Standard',
    E3DC: 'E3DC',
    EnphaseIqEnvoy: 'Enphase IQ Envoy',
    Fenecon: 'FENECON',
    froniusSolarapiV1: 'Fronius Solar Api V1',
    froniusGen24Modbus: 'Fronius Gen24 Modbus TCP/IP',
    kostalPiko: 'Kostal Piko',
    kostalPlenticore: 'Kostal Plenticore',
    kostalSem: 'Kostal Sem',
    kostalSemInverter: 'Kostal Sem Inverter',
    SIEMENS_SENTRON_PAC_FAMILY: 'Siemens Sentron PAC',
    SENEChome: 'SENEC.Home',
    HuaweiSun2000dongle: 'Huawai Sun 2000 dongle',
    HuaweiDongleSensor: 'Huawai Sun 2000 dongle & sensor',
    MTecEbGen2TCP: 'M-TEC Energy Butler GEN2',
    MTecEbGen3TCP: 'M-TEC Energy Butler GEN3',
    Phoenix: 'Phoenix',
    RctPower: 'RCT Power',
    Shelly1PmPv: 'Shelly 1PM PV',
    SmaDataManager: 'SMA Data Manager',
    SmaEnergyMeter: 'SMA Energy Meter',
    SmaHomeManager: 'SMA Home Manager',
    SmaHybrid: 'SMA Hybrid',
    SmaInverter: 'SMA Inverter',
    SolarEdgeHybrid: 'Solar Edge Hybrid',
    SolarEdgeInverter: 'Solar Edge Inverter',
    Solarwatt: 'Solarwatt',
    Solax: 'Solax',
    SolaxCloudApi: 'Solax Cloud',
    Sonnenbatterie: 'sonnenBatterie',
    Sungrow: 'Sungrow',
    SungrowHybrid: 'Sungrow Hybrid',
    Victron: 'Victron Energy',
    xelectrix: 'xelectrix',
    excelFromP1: 'Beginn des ersten Zeitraums:',
    excelFromP2: 'Beginn des zweiten Zeitraums:',
    excelToP1: 'Ende des ersten Zeitraums:',
    excelToP2: 'Ende der zweiten Periode:',
    uploadLoadprofile: 'Lastprofil importieren',
    uploading: 'Importieren',
    uploadStarted: 'Datei-Import erfolgreich gestarted. Dauer ca 5 Minuten',
    uploadFailed: 'Datei-Import gescheitert',
    noDataEnergyFlow: 'Dieser Watt Meter sendet zur Zeit keine Daten.',
    noDataEnergyFlowHelp: 'Brauchen Sie Hilfe? Je nach Farbe der Status-LED gehen Sie bitte wie folgt vor:',
    noDataEnergyFlowLedGrey: 'Versorge den Watt Meter mit Strom',
    noDataEnergyFlowLedBlue1: 'Prüfe ob dein WLAN funktioniert',
    noDataEnergyFlowLedBlue2: 'Wenn du dein WLAN geändert hast, passe die WLAN Einstellungen des Watt Meter an',
    noDataEnergyFlowLedGreen: 'Wende dich an support@watt-analytics.com',
};
